import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './index.css';

const HorizontalGroupSwiper = () => {
  const slideGroups = [
    [require('../../assets/theme-1-1.png'), 
     require('../../assets/theme-2-1.png'),
     require('../../assets/theme-3-1.png')],
    [require('../../assets/theme-1-2.png'),
     require('../../assets/theme-2-2.png'),
     require('../../assets/theme-3-2.png')],
    [require('../../assets/theme-1-3.png'),
     require('../../assets/theme-2-3.png'),
     require('../../assets/theme-3-3.png')],
  ];

  return (
    <div className="group-swiper-container">
      <Swiper
        modules={[Navigation,Pagination]}
        slidesPerView={1}
        spaceBetween={40}
        slidesPerGroup={1}
        navigation={{
          nextEl: '.group-next',
          prevEl: '.group-prev',
        }}  
        pagination={{
          el: '.group-pagination',
          clickable: true,
          bulletClass: 'group-bullet',
          bulletActiveClass: 'group-bullet-active'
        }}
        loop={true}
        speed={800}
      >
        {slideGroups.map((group, index) => (
          <SwiperSlide key={index}>
            <div className="image-group">
              {group.map((img, i) => (
                <div className="group-image-wrapper" key={i}>
                  <img
                    src={img}
                    alt={`主题${index + 1}-图片${i + 1}`}
                    className="group-image"
                  />
                  <img className='bottom-image' src={require(`../../assets/${i+1}-bottom.png`)} />
                </div>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="group-pagination"></div>
      <div className="group-navigation">
        <img
          className="group-prev"
          src={require('../../assets/left-icon.png')}
          alt="上一组"
          role="button"
        />
        <img
          className="group-next"
          src={require('../../assets/right-icon.png')}
          alt="下一组"
          role="button"
        />
      </div>
    </div>
  );
};

export default HorizontalGroupSwiper;